<template>
  <div
    class="v-search-results"
    :class="inline ? ' is-inline' : ''"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <div class="v-search-results__row">
      Showing
      <span v-if="searchResults">
        <span v-if="searchResults > pageLength && pageLength > 0">
          <span class="font-weight-bold">{{ pageLength }} </span>of
        </span>
        <span class="font-weight-bold">{{ searchResults }} </span>
      </span>
      <span v-if="searchTerm">
        {{ searchResults === 1 ? 'result' : 'results' }} for
        <span :class="'value' + (inline ? '' : ' mr-n1')">{{
          searchTerm
        }}</span>
      </span>
      <span v-else class="text-lowercase">{{ searchMode }} applications</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchResults',
  data() {
    return {}
  },
  props: {
    searchResults: {
      type: Number,
      default: 0
    },
    pageLength: {
      type: Number,
      default: 0
    },
    searchTerm: {
      type: String,
      default: ''
    },
    searchMode: {
      type: String,
      default: ''
    },
    inline: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss">
.v-search-results {
  .value {
    font-weight: 700;
    color: $color-primary;
  }
}
.is-inline {
  display: inline-block;
}
</style>
